import { render, staticRenderFns } from "./TotalRecaudacionComponent.vue?vue&type=template&id=3f88988c"
import script from "./TotalRecaudacionComponent.vue?vue&type=script&lang=js"
export * from "./TotalRecaudacionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports